import * as React from 'react';
import { FC } from 'react';
import { v4 as uuidv4 } from 'uuid';
import SingleIngredient from './SingleIngredient';

interface Ingredient {
    name: string | null;
    ingredients: [{
        amount: number,
        id: string,
        ingredientId: string,
        middleText: string,
        name: string,
        postText: string,
        preText: string,
        unit: string,
        unitPluralName: string,
        displayName: string, 
        ingredientLink: string,
    }]
}

interface IngredientsModel {
    ingredientLists: Ingredient[] | null;
    portions: number;
    defaultPortions: number;
}

const Ingredients: FC<IngredientsModel> = (props) => {
    return (
        <>
            {props.ingredientLists !== null && (
                <>
                    {props.ingredientLists.map((group) => (
                        <div key={uuidv4()}>
                            {group.name !== null && (
                                <h3 className="text-center text-lg laptop:text-2xl font-semibold mt-6 mb-3">
                                    {group.name}
                                </h3>
                            )}

                            {group.ingredients.length > 0 && (
                                <ul>
                                    {group.ingredients.map((ingredient) => (
                                        <li className="px-2 py-3 text-lg laptop:text-xl print:text-base print:py-0 border-b border-brown-primary !leading-7 gap-1.5" key={ingredient.id}>
                                            <SingleIngredient ingredient={ingredient} portions={props.portions} defaultPortions={props.defaultPortions} />
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ))}
                </>                
            )}
        </>
    );
};
export default Ingredients;